import React from 'react';

// Compact label / value grid for a record card. `Def` renders nothing when the value is empty so
// callers can list every field without guarding each one.

export const DefGrid: React.FC<{ children: React.ReactNode; className?: string; cols?: 2 | 3 }> = ({ children, className, cols = 3 }) => (
  <dl className={`grid grid-cols-2 ${cols === 3 ? 'md:grid-cols-3' : ''} gap-x-6 gap-y-2 text-sm ${className ?? ''}`}>{children}</dl>
);

export const Def: React.FC<{ label: string; value?: React.ReactNode; mark?: React.ReactNode; wide?: boolean }> = ({ label, value, mark, wide }) => {
  if (value === null || value === undefined || value === '') return null;
  return (
    <div className={wide ? 'col-span-full' : undefined}>
      <dt className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">{label}{mark}</dt>
      <dd className="mt-0.5 text-gray-900 dark:text-gray-100 whitespace-pre-wrap">{value}</dd>
    </div>
  );
};
